export const isValidPositiveNumber = (value: number) =>
  Number.isFinite(value) && value > 0;
